import React, { useState, useMemo, useEffect } from 'react'

import { PageHeader } from 'components/PageHeader'
import { ConfigUtils } from 'utils/config'

import { DrawerItems } from '../DrawerItems'
import { Stores } from '../Stores'
import { Users } from '../Users'
import { UserPolls } from '../UserPoll'
import { Admins } from '../Admins'
import { Styles } from '../Styles'
import { Dayparts } from '../Dayparts'
import { VisitPromotions } from '../Loyalty/VisitPromotions'
import { ReviewsSettings } from '../Reviews/ReviewsSettings'

const ALL_TABS = [
  { key: 'app', label: 'App' },
  { key: 'locales', label: 'Locales' },
  { key: 'daypart', label: 'Daypart' },
  { key: 'usuarios', label: 'Usuarios' },
  { key: 'test', label: 'Test' },
  { key: 'admins', label: 'Administradores' },
  { key: 'dias-especiales', label: 'Días Especiales' },
  { key: 'look-feel', label: 'Look & Feel' },
  { key: 'reviews', label: 'Reviews' },
]

const Configuraciones: React.FC = () => {
  const initialTab = () => {
    const tab = new URLSearchParams(window.location.search).get('tab')
    return tab || 'app'
  }
  const [activeTab, setActiveTab] = useState(initialTab)

  const tabs = useMemo(
    () =>
      ALL_TABS.filter(tab => {
        if (tab.key === 'reviews' && !ConfigUtils.reviews.enabled) {
          return false
        }
        return true
      }),
    [],
  )

  useEffect(() => {
    if (!tabs.find(tab => tab.key === activeTab)) {
      setActiveTab(tabs[0]?.key || 'app')
    }
  }, [tabs, activeTab])

  const handleTabChange = (tabKey: string) => {
    setActiveTab(tabKey)
  }

  const renderContent = () => {
    switch (activeTab) {
      case 'app':
        return <DrawerItems />
      case 'locales':
        return <Stores />
      case 'daypart':
        return <Dayparts />
      case 'usuarios':
        return <Users />
      case 'test':
        return <UserPolls />
      case 'admins':
        return <Admins />
      case 'dias-especiales':
        return <VisitPromotions />
      case 'look-feel':
        return <Styles />
      case 'reviews':
        return ConfigUtils.reviews.enabled ? <ReviewsSettings /> : null
      default:
        return null
    }
  }

  return (
    <div>
      <PageHeader
        title="Configuraciones"
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />
      {renderContent()}
    </div>
  )
}

export { Configuraciones }
